
export default [
  {
    path: '/',
    name: '网站首页',
    redirect:'/index'
  },
  {
    path: 'index',
    name: '首页',
    component: () => import('@/views/homePage/index.vue')
  },
  {
    path: 'framework',
    name: '“1+3体系”',
    component: () => import('@/views/homePage/framework.vue')
  },
  {
    path: 'QualityEvaluation',
    name: '品质评价',
    component: () => import('@/views/homePage/qualityEvaluationService.vue')
  },
  {
    path: 'testService',
    name: '检测服务',
    component: () => import('@/views/homePage/testService.vue')
  },
  {
    path: 'standardService',
    name: '标准服务',
    component: () => import('@/views/homePage/standardService.vue')
  },
  {
    path: 'aboutUs',
    name: '关于我们',
    component: () => import('@/views/homePage/aboutUs.vue')
  }
  
  
]